import React from "react";
import { EventConstants } from "utils/constants";
import { EventHelper } from "utils/helpers";

interface ReloadEventProps {
  render(reloadKey: number, reload: () => void): void;
  uniqueKey?: string;
}

const ReloadEvent: React.FC<ReloadEventProps> = (props) => {
  const [reloadKey, setReload] = React.useState(0);

  const reloadList = () => {
    setReload(reloadKey + 1);
  };

  React.useEffect(() => {
    EventHelper.subscribeEvent(
      EventHelper.getDynamicEventName(EventConstants.RefreshReport, props.uniqueKey ?? ""),
      reloadList
    );

    return () => {
      EventHelper.unsubscribeEvent(
        EventHelper.getDynamicEventName(EventConstants.RefreshReport, props.uniqueKey ?? ""),
        reloadList
      );
    };
  }, []);

  return <>{props.render(reloadKey, reloadList)}</>;
};

export default ReloadEvent;
